import styles from './anmeldungElternbeitraege.module.css';
import { ogs_betreuung } from '../../../../config/references_files';
function AnmeldungElternbeitraege() {
    const handleClick = () => {
        window.open(`/uploads/files/5.75c_satzungerhebungelternbeitraegetagesbetreeung_131223.pdf`, "_blank");
    };
    return (

        <section className={styles.center}>
            <h1>Anmeldung & Elternbeiträge</h1>
            <section>
                < h2 id='anmeldung'>Anmeldung</ h2>
                <ol>
                    <li>Downloaden Sie <a href={ogs_betreuung} target="_blank" rel="noopener noreferrer">hier</a> unseren beschreibbaren Betreuungsvertrag.</li>
                    <li>Senden Sie uns den ausgefüllten Vertrag per E-Mail an unsere Geschäftstelle: <a href='mailto:geschaefsstelle@tus05-oberpleis.de'>geschaefsstelle@tus05-oberpleis.de</a></li>
                    <li>Geben Sie das unterschriebene Dokument bei der OGS oder der Geschäftsstelle des TuS 05 Oberpleis ab</li>
                </ol>
                <ul>
                    <li>Bitte beachten Sie, dass die Anmeldung eines Kindes für das folgende Schuljahr bis zum 15. November abgegeben werden muss.</li>
                    <li>Im Frühjahr des Aufnahmejahres versenden wir die Zusagen.</li>
                </ul>
            </section>


            <section>
                < h2>Elternbeiträge</ h2>
                <p>Der Elternbeitrag für die OGS wird durch den Schulträger, die Stadt Königswinter, festgesetzt und eingezogen. Zu diesem Zweck werden durch den Träger Namen und Anschrift der angemeldeten Kinder und Personensorgeberechtigten aus diesem Vertrag an die Stadt Königswinter weitergegeben.</p>
                <p className={styles.beitrag}><strong>Beitragstabelle für den Besuch der OGS: Staffelung ab dem 01.08.2024.</strong> (Download: <span tabIndex={0} className={styles.download} onClick={handleClick}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {

                            e.preventDefault(); // Prevent space from scrolling
                            handleClick()
                        }
                    }}
                >hier</span>)</p>
                <img className={styles.beitragstabelle}
                    src={`${process.env.PUBLIC_URL}/images/ogs/beitragstabelle_besuch_OGS_2024_08_01.png`}
                    alt="Beitragstabelle für den Besuch der OGS (ab 01.08.2024)"
                    onClick={handleClick} />
                <p className={styles.note}>Die aktuellen Beiträge sind vom Träger ohne Gewähr, die verbindlichen müssen zu gegebener Zeit bei der Stadt Königswinter erfragt werden.</p>
                < h3>Beitrag zur Mittagsverpflegung</ h3>
                <ul>
                    <li>Neben dem Betreuungsentgeld kommen noch <strong>65,00€ / Monat</strong> für die Mittagsverpflegung des OGS.</li>
                    <li>Dieser Beitrag wird monatlich mittels Lastschriftverfahren durch den Träger abgebucht.</li>
                </ul>
                < h3>Mehrere Kinder</ h3>
                <ul>
                    <li>Besuchen mehrere Kinder einer Familie oder einer beitragspflichtigen Person gleichzeitig eine Tageseinrichtung für Kinder in Königswinter, ein Angebot der Offenen Ganztagsgrundschule in Königswinter oder werden Leistungen nach den Richtlinien der Stadt Königswinter über die Förderung der Kindertagespflege gewährt, wird die Beitragspflicht grundsätzlich nur für ein Kind ausgelöst (der höhere Beitrag).</li>
                    <li>Besuchen mehrere Kinder einer Familie oder einer beitragspflichtigen Person gleichzeitig in Königswinter ein Angebot der Offenen Ganztagsgrundschule wird die Beitragspflicht für das 1. Kind zu 100 % und für das Geschwisterkind mit 25 % ausgelöst. Weitere in der OGS betreute Kinder der jeweiligen Familien werden beitragsfrei betreut.</li>
                    <li>Der Beitrag ist aus den laufenden Kosten für das gesamte Schuljahr ermittelt und daher durchgehend auch für die betreuungsfreie Zeit und die Ferienzeit zu zahlen.</li>
                    <li>Soweit während der Schulferien ein Betreuungsprogramm angeboten wird, ist jeweils eine gesonderte Anmeldung erforderlich und es entstehen zusätzliche Kosten.</li>
                    <li>Das Schuljahr beginnt im Sinne der Beitragspflicht am 1. August des Jahres und endet am 31. Juli des folgenden Jahres. Die unmittelbar an den Träger zu entrichtenden Betreuungs- und Essensbeiträge werden grundsätzlich im Lastschriftverfahren eingezogen und sind zum 15. jeden Monats fällig.</li>
                </ul>
            </section>

        </section>
    )
}

export default AnmeldungElternbeitraege;